import {makeStyles} from "@material-ui/styles";
import {createStyles, Theme} from "@material-ui/core";

export const usePatientAdherenceChartStyles = makeStyles((theme: Theme) => createStyles({
    chart: {
        height: '435px',
    },
}));
